import { Box, Code, Group, List, Stack, Text } from '@mantine/core'
import { IconUsb } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'

export const RtspExamples = () => (
  <PlatformAlert variant="info" showIcon={false}>
    <Stack gap="lg">
      <Box>
        <Text size="xs" fw="bold" mb="xs">
          <FormattedMessage id="cameras.add.form.rtspUrl.examples" />
        </Text>

        <List size="xs" spacing="sm">
          <List.Item>
            Axis -
            rtsp://[username]:[password]@[IP_address]:[port]/axis-media/media.amp
          </List.Item>

          <List.Item>
            Bosch - rtsp://[username]:[password]@[IP_address]:[port]/rtsp_tunnel
          </List.Item>

          <List.Item>
            Dahua -
            rtsp://[username]:[password]@[IP_address]:[port]/cam/realmonitor?channel=[channel]&subtype=[stream_type]
          </List.Item>

          <List.Item>
            Hikvision -
            rtsp://[username]:[password]@[IP_address]:[port]/Streaming/Channels/[channel_number]
          </List.Item>
        </List>
      </Box>

      <Group wrap="nowrap" gap="xs">
        <IconUsb size={16} />

        <Text size="xs">
          <FormattedMessage
            id="cameras.add.form.usb.hint"
            values={{
              usbExample: <Code>/dev/video0</Code>
            }}
          />
        </Text>
      </Group>
    </Stack>
  </PlatformAlert>
)
